import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03dcc308&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=03dcc308&prod&lang=scss&scoped=true&vars=%7B%20backGroundImage%2C%20color%20%7D"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dcc308",
  null
  
)

export default component.exports